// import { useState, useMemo } from "react";
// import {
//   LineChart,
//   Line,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   ResponsiveContainer,
// } from "recharts";
// import { Box, Card, Popover, Typography } from "@mui/material";
// import useMediaQueryHook from "@hooks/useMediaQueryHook";
// import stepBack from "@assets/images/stepsBack.jpg";
// import { useTranslation } from "react-i18next";
// import { DateCalendar } from "@mui/x-date-pickers";

// const SleepCoachCharts = ({ graphData = {} ,shouldDisableDate=null}) => {
//   const { isMobile } = useMediaQueryHook();
//   const [calendarAnchor, setCalendarAnchor] = useState(null);
//   const [calendarDate, setCalendarDate] = useState(new Date());
//   const [dataLoading, setDataLoading] = useState(false);

//   const handleOpenCalendar = (event) => {
//     setCalendarAnchor(event.currentTarget);
//   };

//   const handleCloseCalendar = () => setCalendarAnchor(null);
//   const { t } = useTranslation();

//   const [activeTab, setActiveTab] = useState("duration");

//   const chartData = useMemo(() => {
//     if (!graphData) return [];

//     // Helper function to format date from YYYY-MM-DD to DD-MM-YYYY
//     const formatDate = (dateString) => {
//       if (!dateString) return "";

//       try {
//         const [year, month, day] = dateString.split("-");
//         return `${day}-${month}-${year}`;
//       } catch (error) {
//         console.warn("Invalid date format:", dateString);
//         return dateString; // Return original if parsing fails
//       }
//     };

//     let data = [];

//     switch (activeTab) {
//       case "duration":
//         data =
//           graphData?.sleepDuration?.map((item) => ({
//             name: formatDate(item?.name), // Format the date here
//             originalName: item?.name,
//             hours: item?.hours ?? null,
//           })) || [];
//         // if all hours are null → return []
//         // if (data.every((d) => d.hours === null)) return [];
//         return data;

//       case "awakening":
//         data =
//           graphData?.sleepAwakening?.map((item) => {
//             let awakenings = null;
//             switch (item.times) {
//               case "no_wakeup":
//                 awakenings = 0;
//                 break;
//               case "1-2_times":
//                 awakenings = 1;
//                 break;
//               case "2-3_times":
//                 awakenings = 2;
//                 break;
//               case "3-4_times":
//                 awakenings = 3;
//                 break;
//               case "more_than_4_times":
//                 awakenings = 4;
//                 break;
//               default:
//                 awakenings = null;
//             }
//             return {
//               name: formatDate(item?.name), // Format the date here
//               originalName: item?.name,
//               awakenings,
//             };
//           }) || [];
//         // if (data.every((d) => d.awakenings === null)) return [];
//         return data;

//       case "consistency":
//         data =
//           graphData?.sleepConsistency?.map((item) => ({
//             name: formatDate(item?.name), // Format the date here
//             originalName: item?.name,
//             consistency:
//               item?.consistent === true
//                 ? 1
//                 : item?.consistent === false
//                 ? 0
//                 : null,
//           })) || [];
//         // if (data.every((d) => d.consistent === null)) return [];
//         return data;

//       default:
//         return [];
//     }
//   }, [graphData, activeTab, isMobile]);
//   const getDataKey = () => {
//     switch (activeTab) {
//       case "duration":
//         return "hours";
//       case "awakening":
//         return "awakenings";
//       case "consistency":
//         return "consistency";
//       default:
//         return "hours";
//     }
//   };

//   const calculateChartWidth = () => {
//     const dataPoints = chartData.length;
//     const minDataPointsForScroll = 5; // Reduced threshold for mobile

//     if (dataPoints <= minDataPointsForScroll) {
//       return "100%";
//     }

//     // Calculate width based on data points - adjust for mobile
//     const pointsWidth = dataPoints * (isMobile ? 80 : 100);
//     return `${pointsWidth}px`;
//   };

//     const handleDateSelect = (date) => {
//       // if (isDateEnabled(date, weeklyData)) {
//       //   const weekIndex = findWeekIndexForDate(date, weeklyData);
//       //   if (weekIndex !== -1) showWeekData(weekIndex);
//       //   handleCloseCalendar();
//       // }
//     };

//   // Check if we need scroll - use different threshold for mobile
//   const needsScroll = chartData.length > (isMobile ? 5 : 7);

//   // Custom tick formatter for XAxis to handle overflow
//   const renderXAxisTick = ({ x, y, payload }) => {
//     return (
//       <g transform={`translate(${x},${y})`}>
//         <text
//           x={0}
//           y={0}
//           dy={16}
//           textAnchor="middle"
//           fill="#6B7280"
//           fontSize={isMobile ? 10 : 12}
//         >
//           {payload.value}
//         </text>
//       </g>
//     );
//   };

//   return (
//     <div
//       className="p-6 rounded-xl text-white bg-cover h-[100%]"
//       style={{ backgroundImage: `url(${stepBack})` }}
//     >
//       <div className="flex items-center justify-between">
//         <h4 className="text-[16px] font-[Lato] text-white mb-3">
//           {t("sleepCoachPreferences.Your Sleep Report")}
//         </h4>

//         <Popover
//           open={Boolean(calendarAnchor)}
//           anchorEl={calendarAnchor}
//           onClose={handleCloseCalendar}
//           anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
//           transformOrigin={{ vertical: "top", horizontal: "left" }}
//           sx={{
//             "& .MuiPopover-paper": {
//               borderRadius: "12px",
//               boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
//             },
//           }}
//         >
//           <Box sx={{ p: 2 }}>
//             <Typography
//               variant="h6"
//               sx={{ fontWeight: 600, color: "#0575E6", mb: 2 }}
//             >
//               Select Week
//             </Typography>
//             <DateCalendar
//               value={calendarDate}
//               onChange={handleDateSelect}
//               // renderDay={renderDay}
//               shouldDisableDate={shouldDisableDate}
//               sx={{ "& .MuiPickersDay-root": { fontSize: "0.875rem" } }}
//               disabled={dataLoading}
//             />
//             {/* <Typography
//               variant="caption"
//               sx={{ color: "#666", mt: 2, display: "block" }}
//             >
//               Note: Only weeks with data are selectable
//             </Typography> */}
//           </Box>
//         </Popover>
//       </div>

//       <div className="bg-white rounded-2xl p-6">
//         {/* Tabs */}
//         <div className="flex flex-col md:flex-row bg-white rounded-full p-1 md:border md:border-[#E9E9E9] w-full gap-1 my-3">
//           <button
//             onClick={() => setActiveTab("duration")}
//             className={`${
//               activeTab === "duration"
//                 ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
//                 : "text-gray-600 hover:bg-gray-100"
//             } px-4 py-2 rounded-full text-[10px] md:text-[12px] font-medium flex-1 border border-[#E9E9E9] md:border-none`}
//           >
//             {t("sleepCoachPreferences.Sleep Duration")}
//           </button>

//           <button
//             onClick={() => setActiveTab("awakening")}
//             className={`${
//               activeTab === "awakening"
//                 ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
//                 : "text-gray-600 hover:bg-gray-100"
//             } px-4 py-2 rounded-full text-[10px] md:text-[12px] font-medium flex-1 border border-[#E9E9E9] md:border-none`}
//           >
//             {t("sleepCoachPreferences.Night Awakenings")}
//           </button>

//           <button
//             onClick={() => setActiveTab("consistency")}
//             className={`${
//               activeTab === "consistency"
//                 ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
//                 : "text-gray-600 hover:bg-gray-100"
//             } px-4 py-2 rounded-full text-[10px] md:text-[12px] font-medium flex-1 border border-[#E9E9E9] md:border-none`}
//           >
//             {t("sleepCoachPreferences.Bedtime Consistency")}
//           </button>
//         </div>

//         {/* Chart */}
//         {chartData?.length > 0 ? (
//           <div className="relative">
//             {/* Scrollable container for all screens when data is large */}
//             <div
//               className={`overflow-x-auto overflow-y-visible ${
//                 needsScroll
//                   ? "scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 pb-2"
//                   : ""
//               }`}
//               style={{
//                 width: "100%",
//               }}
//             >
//               <div
//                 style={{
//                   width: calculateChartWidth(),
//                   minWidth: "100%",
//                 }}
//               >
//                 <ResponsiveContainer
//                   width="100%"
//                   height={activeTab === "consistency" ? 100 : 300}
//                 >
//                   <LineChart
//                     data={chartData}
//                     margin={
//                       isMobile
//                         ? { top: 5, right: 10, left: 0, bottom: 25 } // Increased bottom margin for dates
//                         : { top: 5, right: 20, left: 0, bottom: 5 }
//                     }
//                   >
//                     <CartesianGrid
//                       strokeDasharray="3 3"
//                       vertical={false}
//                       stroke="#D6D6D6"
//                     />
//                     <XAxis
//                       dataKey="name"
//                       axisLine={false}
//                       tickLine={false}
//                       tick={renderXAxisTick} // Use custom tick renderer
//                       interval={
//                         needsScroll || isMobile ? "preserveStartEnd" : 0
//                       }
//                       padding={{ left: 15, right: 15 }}
//                       height={isMobile ? 40 : 30}
//                     />
//                     <YAxis
//                       axisLine={false}
//                       tickLine={false}
//                       allowDecimals={false}
//                       tick={{
//                         fill: "#6B7280",
//                         fontSize: isMobile ? 10 : 12,
//                       }}
//                       domain={
//                         activeTab === "awakening"
//                           ? [0, 4]
//                           : activeTab === "consistency"
//                           ? [0, 1]
//                           : [0, 8]
//                       }
//                       tickFormatter={(value) => {
//                         if (activeTab === "consistency")
//                           return value ? "Yes" : "No";
//                         return value;
//                       }}
//                       width={isMobile ? 30 : 40} // Adjust YAxis width for mobile
//                     />

//                     <Tooltip
//                       formatter={(value) =>
//                         activeTab === "duration"
//                           ? `${value}h`
//                           : activeTab === "awakening"
//                           ? `${value} times`
//                           : value
//                           ? "consistent"
//                           : "inconsistent"
//                       }
//                       labelFormatter={(label, payload) => {
//                         // Show original full date in tooltip
//                         if (
//                           payload &&
//                           payload[0] &&
//                           payload[0].payload.originalName
//                         ) {
//                           return payload[0].payload.originalName;
//                         }
//                         return label;
//                       }}
//                     />
//                     <Line
//                       type="monotone"
//                       dataKey={getDataKey()}
//                       isAnimationActive={false}
//                       stroke="#3B82F6"
//                       strokeWidth={3}
//                       connectNulls={false}
//                       dot={(props) => {
//                         const { cx, cy, value } = props;
//                         if (value === null || value === undefined) return null;
//                         return (
//                           <circle
//                             cx={cx}
//                             cy={cy}
//                             r={isMobile ? 3 : 5}
//                             fill="#3B82F6"
//                             stroke="white"
//                             strokeWidth={1}
//                           />
//                         );
//                       }}
//                       activeDot={(props) => {
//                         const { cx, cy, value } = props;
//                         if (value === null || value === undefined) return null;
//                         return (
//                           <circle
//                             cx={cx}
//                             cy={cy}
//                             r={isMobile ? 5 : 8}
//                             fill="#3B82F6"
//                             stroke="white"
//                             strokeWidth={2}
//                           />
//                         );
//                       }}
//                     />
//                   </LineChart>
//                 </ResponsiveContainer>
//               </div>
//             </div>

//             {/* Scroll hint for users */}
//             {needsScroll && (
//               <div className="text-center mt-2">
//                 <p className="text-xs text-gray-500">
//                   ← Scroll horizontally to see more data →
//                 </p>
//               </div>
//             )}
//           </div>
//         ) : (
//           <div className="flex items-center justify-center h-[300px]">
//             <div className="text-center text-gray-500">
//               <svg
//                 className="w-16 h-16 mx-auto mb-4 text-gray-300"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
//                 />
//               </svg>
//               <p className="text-[14px] font-[500] mb-1">
//                 {t("No Data Available")}
//               </p>
//               <p className="text-[12px] text-gray-400">
//                 {t(
//                   "Your sleep data will appear here once you complete your daily check-in and enter your sleep details. Please mark your day as done to start tracking your sleep insights."
//                 )}
//               </p>
//             </div>
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// export default SleepCoachCharts;



import { useState, useMemo } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
import { Box, Popover, Typography, IconButton } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import useMediaQueryHook from "@hooks/useMediaQueryHook";
import stepBack from "@assets/images/stepsBack.jpg";
import { useTranslation } from "react-i18next";
import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import dayjs from "dayjs";

const SleepCoachCharts = ({ 
  graphData = {}, 
  shouldDisableDate = null,
  onDateSelect,
  setGraphData,
  loading = false 
}) => {
  const { isMobile } = useMediaQueryHook();
  const [calendarAnchor, setCalendarAnchor] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState("duration");

  const handleOpenCalendar = (event) => {
    setCalendarAnchor(event.currentTarget);
  };

  const handleCloseCalendar = () => {
    setCalendarAnchor(null);
  };

const handleDateSelect = async (date) => {
  try {
    handleCloseCalendar();

    const formattedDate = dayjs(date).format("YYYY-MM-DD");

    setSelectedDate(formattedDate);

    if (onDateSelect && typeof onDateSelect === "function") {
      await onDateSelect(formattedDate);
    }
  } catch (error) {
    console.error("Error selecting date:", error);
  }
};

  const chartData = useMemo(() => {
    if (!graphData) return [];

    const formatDate = (dateString) => {
      if (!dateString) return "";
      try {
        const [year, month, day] = dateString.split("-");
        return `${day}-${month}-${year}`;
      } catch (error) {
        console.warn("Invalid date format:", dateString);
        return dateString;
      }
    };

    let data = [];
    switch (activeTab) {
      case "duration":
        data = graphData?.sleepDuration?.map((item) => ({
          name: formatDate(item?.name),
          originalName: item?.name,
          hours: item?.hours ?? null,
        })) || [];
        return data;

      case "awakening":
        data = graphData?.sleepAwakening?.map((item) => {
          let awakenings = null;
          switch (item.times) {
            case "no_wakeup":
              awakenings = 0;
              break;
            case "1-2_times":
              awakenings = 1;
              break;
            case "2-3_times":
              awakenings = 2;
              break;
            case "3-4_times":
              awakenings = 3;
              break;
            case "more_than_4_times":
              awakenings = 4;
              break;
            default:
              awakenings = null;
          }
          return {
            name: formatDate(item?.name),
            originalName: item?.name,
            awakenings,
          };
        }) || [];
        return data;

      case "consistency":
        data = graphData?.sleepConsistency?.map((item) => ({
          name: formatDate(item?.name),
          originalName: item?.name,
          consistency:
            item?.consistent === true
              ? 1
              : item?.consistent === false
              ? 0
              : null,
        })) || [];
        return data;

      default:
        return [];
    }
  }, [graphData, activeTab, isMobile]);

  const getDataKey = () => {
    switch (activeTab) {
      case "duration":
        return "hours";
      case "awakening":
        return "awakenings";
      case "consistency":
        return "consistency";
      default:
        return "hours";
    }
  };

  const calculateChartWidth = () => {
    const dataPoints = chartData.length;
    const minDataPointsForScroll = 5;
    if (dataPoints <= minDataPointsForScroll) return "100%";
    const pointsWidth = dataPoints * (isMobile ? 80 : 100);
    return `${pointsWidth}px`;
  };

  const needsScroll = chartData.length > (isMobile ? 5 : 7);

  const renderXAxisTick = ({ x, y, payload }) => {
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={16}
          textAnchor="middle"
          fill="#6B7280"
          fontSize={isMobile ? 10 : 12}
        >
          {payload.value}
        </text>
      </g>
    );
  };

    const getDisableDates = (date) => {
      if (!shouldDisableDate?.length) return true;
  
      const dateString = dayjs(date).format("YYYY-MM-DD");
      return !shouldDisableDate.includes(dateString);
    };

  return (
     <LocalizationProvider dateAdapter={AdapterDateFns}>
    <div
      className="p-6 rounded-xl text-white bg-cover h-[100%]"
      style={{ backgroundImage: `url(${stepBack})` }}
    >
      <div className="flex items-center justify-between mb-4">
        <h4 className="text-[16px] font-[Lato] text-white">
          {t("sleepCoachPreferences.Your Sleep Report")}
        </h4>
        
        <IconButton
          onClick={handleOpenCalendar}
          sx={{
            color: "white",
            backgroundColor: "#fff",
            "&:hover": {
              backgroundColor: "#dbd7d7ff",
            },
            borderRadius:"12px"
          }}
          disabled={loading}
        >
          <CalendarMonthIcon style={{ fontSize: 18, color: "#0575E6" }} />
        </IconButton>
      </div>

      {/* Calendar Popover */}
      <Popover
        open={Boolean(calendarAnchor)}
        anchorEl={calendarAnchor}
        onClose={handleCloseCalendar}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{
          "& .MuiPopover-paper": {
            borderRadius: "12px",
            boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
            overflow: "hidden",
          },
        }}
      >
        <Box sx={{ p: 2, minWidth: isMobile ? 280 : 320 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 600,
              color: "#0575E6",
              mb: 2,
              fontSize: isMobile ? "1rem" : "1.125rem",
            }}
          >
            Select Date
          </Typography>
          
          <DateCalendar
            value={selectedDate}
            onChange={handleDateSelect}
            shouldDisableDate={getDisableDates}
            disabled={loading}
            sx={{
              "& .MuiPickersDay-root": {
                fontSize: isMobile ? "0.75rem" : "0.875rem",
                width: isMobile ? 32 : 36,
                height: isMobile ? 32 : 36,
              },
              "& .MuiPickersDay-root.Mui-disabled": {
                color: "text.disabled",
                backgroundColor: "action.hover",
              },
              "& .MuiDayCalendar-weekContainer": {
                marginBottom: 1,
              },
            }}
          />
          
          {loading && (
            <Typography
              variant="caption"
              sx={{
                color: "#666",
                mt: 2,
                display: "block",
                textAlign: "center",
              }}
            >
              Loading data...
            </Typography>
          )}
        </Box>
      </Popover>

      <div className="bg-white rounded-2xl p-6">
        {/* Tabs */}
        <div className="flex flex-col md:flex-row bg-white rounded-full p-1 md:border md:border-[#E9E9E9] w-full gap-1 my-3">
          <button
            onClick={() => setActiveTab("duration")}
            className={`${
              activeTab === "duration"
                ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
                : "text-gray-600 hover:bg-gray-100"
            } px-4 py-2 rounded-full text-[10px] md:text-[12px] font-medium flex-1 border border-[#E9E9E9] md:border-none`}
            disabled={loading}
          >
            {t("sleepCoachPreferences.Sleep Duration")}
          </button>

          <button
            onClick={() => setActiveTab("awakening")}
            className={`${
              activeTab === "awakening"
                ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
                : "text-gray-600 hover:bg-gray-100"
            } px-4 py-2 rounded-full text-[10px] md:text-[12px] font-medium flex-1 border border-[#E9E9E9] md:border-none`}
            disabled={loading}
          >
            {t("sleepCoachPreferences.Night Awakenings")}
          </button>

          <button
            onClick={() => setActiveTab("consistency")}
            className={`${
              activeTab === "consistency"
                ? "bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white"
                : "text-gray-600 hover:bg-gray-100"
            } px-4 py-2 rounded-full text-[10px] md:text-[12px] font-medium flex-1 border border-[#E9E9E9] md:border-none`}
            disabled={loading}
          >
            {t("sleepCoachPreferences.Bedtime Consistency")}
          </button>
        </div>

        {/* Chart */}
        {loading ? (
          <div className="flex items-center justify-center h-[300px]">
            <div className="text-center">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
              <p className="text-[14px] font-[500] text-gray-600">
                Loading sleep data...
              </p>
            </div>
          </div>
        ) : chartData?.length > 0 ? (
          <div className="relative">
            <div
              className={`overflow-x-auto overflow-y-visible ${
                needsScroll
                  ? "scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100 pb-2"
                  : ""
              }`}
              style={{ width: "100%" }}
            >
              <div
                style={{
                  width: calculateChartWidth(),
                  minWidth: "100%",
                }}
              >
                <ResponsiveContainer
                  width="100%"
                  height={activeTab === "consistency" ? 100 : 300}
                >
                  <LineChart
                    data={chartData}
                    margin={
                      isMobile
                        ? { top: 5, right: 10, left: 0, bottom: 25 }
                        : { top: 5, right: 20, left: 0, bottom: 5 }
                    }
                  >
                    <CartesianGrid
                      strokeDasharray="3 3"
                      vertical={false}
                      stroke="#D6D6D6"
                    />
                    <XAxis
                      dataKey="name"
                      axisLine={false}
                      tickLine={false}
                      tick={renderXAxisTick}
                      interval={needsScroll || isMobile ? "preserveStartEnd" : 0}
                      padding={{ left: 15, right: 15 }}
                      height={isMobile ? 40 : 30}
                    />
                    <YAxis
                      axisLine={false}
                      tickLine={false}
                      allowDecimals={false}
                      tick={{
                        fill: "#6B7280",
                        fontSize: isMobile ? 10 : 12,
                      }}
                      domain={
                        activeTab === "awakening"
                          ? [0, 4]
                          : activeTab === "consistency"
                          ? [0, 1]
                          : [0, 8]
                      }
                      tickFormatter={(value) => {
                        if (activeTab === "consistency")
                          return value ? "Yes" : "No";
                        return value;
                      }}
                      width={isMobile ? 30 : 40}
                    />
                    <Tooltip
                      formatter={(value) =>
                        activeTab === "duration"
                          ? `${value}h`
                          : activeTab === "awakening"
                          ? `${value} times`
                          : value
                          ? "consistent"
                          : "inconsistent"
                      }
                      labelFormatter={(label, payload) => {
                        if (payload?.[0]?.payload?.originalName) {
                          return payload[0].payload.originalName;
                        }
                        return label;
                      }}
                    />
                    <Line
                      type="monotone"
                      dataKey={getDataKey()}
                      isAnimationActive={false}
                      stroke="#3B82F6"
                      strokeWidth={3}
                      connectNulls={false}
                      dot={(props) => {
                        const { cx, cy, value } = props;
                        if (value === null || value === undefined) return null;
                        return (
                          <circle
                            cx={cx}
                            cy={cy}
                            r={isMobile ? 3 : 5}
                            fill="#3B82F6"
                            stroke="white"
                            strokeWidth={1}
                          />
                        );
                      }}
                      activeDot={(props) => {
                        const { cx, cy, value } = props;
                        if (value === null || value === undefined) return null;
                        return (
                          <circle
                            cx={cx}
                            cy={cy}
                            r={isMobile ? 5 : 8}
                            fill="#3B82F6"
                            stroke="white"
                            strokeWidth={2}
                          />
                        );
                      }}
                    />
                  </LineChart>
                </ResponsiveContainer>
              </div>
            </div>

            {needsScroll && (
              <div className="text-center mt-2">
                <p className="text-xs text-gray-500">
                  ← Scroll horizontally to see more data →
                </p>
              </div>
            )}
          </div>
        ) : (
          <div className="flex items-center justify-center h-[300px]">
            <div className="text-center text-gray-500">
              <svg
                className="w-16 h-16 mx-auto mb-4 text-gray-300"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                />
              </svg>
              <p className="text-[14px] font-[500] mb-1">
                {t("No Data Available")}
              </p>
              <p className="text-[12px] text-gray-400">
                {t(
                  "Your sleep data will appear here once you complete your daily check-in and enter your sleep details. Please mark your day as done to start tracking your sleep insights."
                )}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
    </LocalizationProvider>
  );
};

export default SleepCoachCharts;